import React from 'react'
import { Drawer, Select, Mentions, Button, Tag, Tooltip } from 'antd'
import style from './style.module.scss'
import { withRouter } from 'react-router'
import SignalCasesService from 'services/signal_cases'
import Common from 'services/common'
const { Option } = Select
class NotesComp extends React.Component {
  constructor(props) {
    super(props)
    this.messagesEndRef = React.createRef()
    this.inputField = React.createRef()
    this.stopNotesList = null
    this.state = {
      SSID: localStorage.getItem('SSID'),
      scopeId: this.props.urlData['scopeId'],
      clusterId: this.props.urlData['clusterId'],
      casesList: [],
      filteredCasesList: [],
      inputValue: '',
      selectedCase: {},
      NoteMsg: '',
      NotesList: [],
      UsersList: [],
      tagList: [],
      UserDetails: Common.getUserPayload(),
      messageStatus: 'Save',
      openScrollToBottom: true,
    }
  }

  componentDidMount() {
    this.getAlloverUsersList()
    this.getAllCasesData()
    if (typeof this.props.CaseData !== 'undefined') {
      this.setState({ selectedCase: this.props.CaseData }, () => {
        this.getNotesList(this.props.CaseData, true)
      })
    }
    this.stopNotesList = setInterval(() => {
      if (Object.keys(this.state.selectedCase).length > 0 && this.state.NotesList.length > 0) {
        this.getNotesList(this.state.selectedCase, false)
      }
    }, 2000)
  }

  componentWillUnmount() {
    clearInterval(this.stopNotesList)
  }

  scrollToBottom = () => {
    const { NotesList } = this.state
    if (this.messagesEnd && this.messagesEnd !== null && document.getElementById(NotesList[NotesList.length - 1].notes))
      this.messagesEnd.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }

  getAllCasesData = pageSize => {
    var param = {
      scope_id: this.state.scopeId,
      pageno: 1,
      pagesize: pageSize ? pageSize : 200,
      addfilters: [
        {
          filter_condition: 'AND',
          filter_key: 'status',
          filter_operand: '=',
          filter_value: 'OPEN',
        },
      ],
    }
    SignalCasesService.getallCaseslist(param, this.state.SSID, this.state.clusterId)
      .then(response => {
        if (response.data.status === 'invalid') {
          Common.sessionExpiry()
        }
        if (response.data.status === 'failed') {
          if (response.data.message === 'user not authorised') {
            Common.UpdateUI_withNewAccess()
          }
          Common.showNotifications('error', 'Something went wrong')
        }
        if (response.data.status === 'success') {
          let cases = response.data.data
          if (this.props.CaseData !== undefined && this.props.CaseData.status === 'CLOSED') {
            cases.push(this.props.CaseData)
          }
          this.setState({ casesList: cases, filteredCasesList: cases })
          if (param.pagesize !== response.data.count && response.data.count > param.pagesize) {
            this.getAllCasesData(response.data.count)
          }
        }
      })
      .catch(err => {
        this.setState({ showLoader: false })
        Common.showNotifications('error', err?.response?.data?.message ? err?.response?.data?.message : 'Something went wrong')
      })
  }

  setCaseData = data => {
    this.setState({ selectedCase: data })
    this.getNotesList(data, true)
  }

  getNotesList = (selected, scroll) => {
    var param = {
      case_id: [selected.case_id],
      scope_id: this.state.scopeId,
    }

    SignalCasesService.listNotes(param, this.state.SSID, this.state.clusterId)
      .then(response => {
        if (response.data.status === 'invalid') {
          Common.sessionExpiry()
        }
        if (response.data.status === 'failed') {
          if (response.data.message === 'user not authorised') {
            Common.UpdateUI_withNewAccess()
          }
          Common.showNotifications('error', 'Something went wrong')
        }
        if (response.data.status === 'success') {
          this.setState({ NotesList: response.data.data[0][selected.case_id] }, () => {
            if (scroll) this.scrollToBottom()
          })
        }
      })
      .catch(err => {
        this.setState({ showLoader: false })
        Common.showNotifications('error', err?.response?.data?.message ? err?.response?.data?.message : 'Something went wrong')
      })
  }

  getAlloverUsersList = userPageSize => {
    var param = {
      scope_id: this.state.scopeId,
      pageno: 1,
      pagesize: userPageSize ? userPageSize : 10,
    }
    SignalCasesService.getUsersList(param, this.state.SSID, this.state.clusterId)
      .then(response => {
        if (response.data.status === 'invalid') {
          Common.sessionExpiry()
        }
        if (response.data.status === 'success') {
          this.setState({ UsersList: response.data.data })
          if (param.pagesize !== response.data.count && response.data.count > param.pagesize) {
            this.getAlloverUsersList(response.data.count)
          }
        }
      })
      .catch(err => {
        this.setState({ showLoader: false })
        Common.showNotifications('error', err?.response?.data?.message ? err?.response?.data?.message : 'Something went wrong')
      })
  }

  setTagList = item => {
    var tagList = this.state.tagList
    tagList.push(item.name)
  }

  addNotes = Msg => {
    var param = {
      case_id: this.state.selectedCase.case_id,
      scope_id: this.state.scopeId,
      notes: this.escapeHtml(Msg),
      author: this.state.UserDetails.email,
      tag_list: [],
    }

    SignalCasesService.addNotetoCase(param, this.state.SSID, this.state.clusterId)
      .then(response => {
        if (response.data.status === 'invalid') {
          Common.sessionExpiry()
        }
        if (response.data.status === 'failed') {
          if (response.data.message === 'user not authorised') {
            Common.UpdateUI_withNewAccess()
          }
          Common.showNotifications('error', 'Something went wrong')
        }
        if (response.data.status === 'success') {
          this.setState({ NoteMsg: '', messageStatus: 'Saved' }, () => {
            this.inputField.rcMentions.state.value = ''
            this.getNotesList(this.state.selectedCase, true)
          })
          setTimeout(() => this.setState({ messageStatus: 'Save' }), 1000)
        }
      })
      .catch(err => {
        this.setState({ showLoader: false })
        this.setState({ messageStatus: 'Retry' })
      })
  }

  replaceURLs = message => {
    if (!message) return

    var urlRegex = /(((https?:\/\/)|(www\.))[^\s]+)/g
    return document.getElementById(message)
      ? (document.getElementById(message).innerHTML = message.replace(urlRegex, function (url) {
        var hyperlink = url
        if (!hyperlink.match('^https?://')) {
          hyperlink = 'https://' + hyperlink
        }
        return (
          '<a href="' +
          hyperlink +
          '" style="cursor: pointer; color:#00bfff;" target="_blank" rel="noopener noreferrer">' +
          url +
          '</a>'
        )
      }))
      : this.escapeHtml(message)
  }

  escapeHtml = text => {
    var map = {
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#039;'
    };

    return text.replace(/[&<>"']/g, function (m) { return map[m]; });
  }


  // filter cases
  searchCases = () => {
    const casesFiltered = []
    const { casesList, inputValue } = this.state
    for (var c = 0; c < casesList.length; c++) {
      if (casesList[c].case_name.toLowerCase().includes(inputValue.toLowerCase()))
        casesFiltered.push(casesList[c])
    }

    this.setState({
      filteredCasesList: casesFiltered,
      //inputValue: '',
    })
  }

  handleSubmit = e => {
    e.preventDefault()
    const { NoteMsg } = this.state
    if (NoteMsg !== undefined && NoteMsg !== null) {
      this.addNotes(NoteMsg.trim())
    }
  }

  render() {
    const {
      messageStatus,
      NotesList,
      UsersList,
      selectedCase,
      filteredCasesList,
      NoteMsg,
    } = this.state
    const ContentDOM = (
      <div style={{ maxHeight: document.body.clientHeight - 85 }}>
        <Select
          style={{
            width: this.props.type === 'drawer' ? '100%' : '95%',
          }}
          className="scroll-barStyle"
          showSearch
          // optionFilterProp="children"
          placeholder="Select Case"
          onSearch={val =>
            this.setState({ inputValue: val }, () => {
              // console.log(this.state.inputValue)
              this.searchCases()
            })
          }
          defaultValue={this.props.CaseData ? this.props.CaseData.case_name : ''}
        >
          {filteredCasesList.map(item => (
            <Option
              value={item.case_name}
              key={item.case_name}
              onClick={() => {
                this.setState(
                  {
                    NotesList: [],
                  },
                  () => this.setCaseData(item),
                )
              }}
            >
              <div
                style={{
                  cursor: 'pointer',
                  display: 'inline-flex',
                  width: this.props.type === 'drawer' ? '385px' : '365px',
                  fontFamily: 'Mukta',
                }}
              >
                <div
                  style={{
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    maxWidth: this.props.type === 'drawer' ? '300px' : '280px',
                    marginTop: '0px',
                    fontWeight: 'bold',
                  }}
                >
                  {item.case_name}
                </div>

                <span style={{ margin: '0 0 0 auto' }}>
                  <Tag
                    style={{
                      marginRight: 0,
                      marginTop: 2,
                    }}
                  >
                    <span
                      className={style.TagSeverity}
                      style={{
                        backgroundColor:
                          item.severity === 'Critical'
                            ? '#D5493C'
                            : item.severity === 'High'
                              ? '#EA671B'
                              : item.severity === 'Medium'
                                ? '#F3C300'
                                : item.severity === 'Low'
                                  ? '#389837'
                                  : item.severity === 'None'
                                    ? 'white'
                                    : null,
                      }}
                    ></span>
                    {item.severity}
                  </Tag>
                </span>
              </div>
            </Option>
          ))}
        </Select>

        {this.props.type === 'non-drawer' ? (
          <span style={{ float: 'right', marginRight: '5px' }}>
            <span
              style={{
                position: 'absolute',
                right: '8px',
                cursor: 'pointer',
                marginTop: '5px',
              }}
              onClick={() => {
                if (this.stopNotesList) {
                  clearInterval(this.stopNotesList)
                }
                this.setState({ selectedCase: {}, NotesList: [] }, () =>
                  this.props.setPanelVisibility(),
                )
              }}
            >
              <Tooltip title={'Close'}>
                <i className="fal fa-arrow-to-right"></i>
              </Tooltip>
            </span>
          </span>
        ) : null}
        <hr style={{ background: '#222427', margin: '8px 0', height: '1px' }} />

        {Object.keys(selectedCase).length > 0 ? (
          <div>
            <div
              style={{
                maxHeight:
                  this.props.type === 'non-drawer'
                    ? document.body.clientHeight - 210
                    : document.body.clientHeight - 198,
                minHeight:
                  this.props.type === 'non-drawer'
                    ? document.body.clientHeight - 210
                    : document.body.clientHeight - 198,
                // background: 'rgb(46, 49, 52)',
                borderRadius: '4px',
                overflow: 'auto',
                margin: '0px 5px 0px 0px',
              }}
              className="scroll-barStyle"
            >
              <table style={{ width: '100%' }}>
                <tbody>
                  {NotesList.map((noteData, index) =>
                    noteData.author === 'DNIF' ? (
                      <tr>
                        <td>
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'center',
                              margin: '4px auto',
                              padding: '0px 25px',
                            }}
                          >
                            <div
                              style={{
                                textAlign: 'center',
                                backgroundColor: '#374049',
                                padding: '4px 8px',
                                borderRadius: '4px',
                              }}
                            >
                              <span
                                style={{
                                  color: '#ffffffc4',
                                  margin: '0px 4px',
                                  fontSize: '12px',
                                }}
                              >
                                {noteData.notes}
                              </span>

                              <span
                                style={{
                                  color: '#8e8e8e',
                                  marginLeft: '5px',
                                  fontSize: '12px',
                                }}
                              >
                                - {Common.getformatedTime(noteData.cnam_time, 'relative')}
                              </span>
                            </div>
                          </div>
                        </td>
                      </tr>
                    ) : (
                      <tr>
                        <td
                          style={{
                            padding: '2px 2px',
                            margin: '2px 0px',
                          }}
                        >
                          <div
                            style={{
                              color: '#d3d3d3',
                              display: 'inline-flex',
                              marginLeft: '8px',
                            }}
                          >
                            <span
                              style={{
                                marginRight: '5px',
                                fontSize: '12px',
                              }}
                            >
                              <i className="fal fa-user"></i>
                            </span>
                            <span style={{ fontSize: '12px' }}>{noteData.author}</span>
                            <div
                              style={{
                                fontSize: '12px',
                                color: '#757575',
                                marginLeft: 'inherit',
                              }}
                            >
                              {Common.getformatedTime(noteData.cnam_time, 'relative')}
                            </div>
                          </div>

                          <div
                            style={{
                              overflowWrap: 'anywhere',
                              fontSize: '12px',
                              background: '#2E3032',
                              padding: '6px 8px',
                              margin: '4px 2px 4px 2px',
                              borderRadius: '4px',
                              userSelect: 'text',
                              fontWeight: 'bolder',
                            }}
                            id={noteData.notes}
                            ref={el => {
                              if (NotesList.indexOf(noteData) === NotesList.length - 1)
                                this.messagesEnd = el
                              else this.messagesEnd = null
                            }}
                          >
                            <span>{this.replaceURLs(noteData.notes)}</span>
                          </div>
                        </td>
                      </tr>
                    ),
                  )}
                </tbody>
              </table>
            </div>

            <hr
              style={{
                background: '#222427',
                margin: '6px 0',
                height: '1px',
              }}
            />
            <div style={{ display: 'flex', marginTop: '11px' }}>
              {' '}
              <Mentions
                ref={input => {
                  this.inputField = input
                }}
                className="scroll-barStyle"
                required
                placement="top"
                placeholder="Enter Notes..."
                rows={1}
                style={{ width: '83%', outline: 'none' }}
                autoFocus={true}
                onChange={value => {
                  if (value.trim()) {
                    this.setState({ messageStatus: 'Save', NoteMsg: value })
                  } else this.setState({ NoteMsg: '' })
                }}
              >
                {UsersList.map(data => (
                  <Option value={data.name}>
                    <span
                      onClick={() => {
                        this.setTagList(data)
                      }}
                    >
                      {data.name}
                    </span>
                  </Option>
                ))}
              </Mentions>
              <Button
                type="primary"
                className={'Notes-Save'}
                style={{
                  padding: '0px 5px',
                  color: '#161819',
                  cursor: 'pointer',
                  margin: '0px 6px 0px',
                  height: '30px',
                  width: '64px',
                  fontWeight: 'bold',
                  fontSize: '1rem',
                }}
                disabled={!NoteMsg.trim()}
                size={'large'}
                onClick={e => this.handleSubmit(e)}
              >
                {messageStatus === 'Saved' ? (
                  <i
                    className="fal fa-check"
                    style={{ color: '#3fc833', marginRight: '3px', fontSize: '10px' }}
                  ></i>
                ) : null}
                {messageStatus === 'Retry' ? (
                  <i
                    className="fal fa-redo"
                    style={{ color: '#161819', marginRight: '3px', fontSize: '10px' }}
                  ></i>
                ) : null}

                {messageStatus}
              </Button>
            </div>
          </div>
        ) : (
          <div style={{ textAlign: 'center', color: '#757575' }}>
            <span>
              <i className="fal fa-comment-alt"></i> NO CASE SELECTED
            </span>
          </div>
        )}
      </div>
    )

    if (this.props.type === 'drawer') {
      return (
        <Drawer
          title={
            <>
              <div className={style.DrawerTitle}>
                <span>
                  <strong>Notes</strong>
                </span>
                <span style={{ float: 'right' }}>
                  <span
                    style={{ position: 'absolute', right: '8px', cursor: 'pointer' }}
                    onClick={() => {
                      if (this.stopNotesList) {
                        clearInterval(this.stopNotesList)
                      }
                      this.setState(
                        {
                          selectedCase: {},
                          NotesList: [],
                        },
                        () => {
                          this.props.setPanelVisibility()
                        },
                      )
                    }}
                  >
                    <Tooltip title={'Close'}>
                      <i className="fal fa-arrow-to-right"></i>
                    </Tooltip>
                  </span>
                </span>
              </div>
            </>
          }
          width={448}
          style={{ marginTop: '44px' }}
          placement="right"
          closable={false}
          mask={true}
          keyboard={true}
          onClose={() => {
            if (this.stopNotesList) {
              clearInterval(this.stopNotesList)
            }
            this.setState(
              {
                selectedCase: {},
                NotesList: [],
              },
              () => {
                this.props.setPanelVisibility()
              },
            )
          }}
          visible={this.props.visible}
        >
          {ContentDOM}
        </Drawer>
      )
    } else {
      if (this.props.type === 'non-drawer') {
        return (
          <Drawer
            width={448}
            style={{ marginTop: '82px' }}
            placement="right"
            closable={false}
            mask={true}
            keyboard={true}
            visible={this.props.visible}
          >
            <div>{ContentDOM}</div>
          </Drawer>
        )
      }
    }
  }
}

export default withRouter(NotesComp)
